module.exports = __webpack_public_path__ + "static/media/cover-image-eurostar.6948ef8c.jpg";